import {
  CustomerPaymentMethodsException,
} from '@/domain/stripe/customer/sub-domains/paymentMethod/repository/contract/exception/CustomerPaymentMethodsException'

export class CouldNotCreateSetupIntentException extends CustomerPaymentMethodsException {

}